import React, {Component} from 'react';
import {Row, Col, Tag} from 'antd';
import Footer from "../exercise/Footer";
import {reverseParseTextView} from "../aiEnReading/createRender";

class Question extends Component {
    state = {
        visible: false
    };

    toggleAnswer = (val, e) => {
        e.stopPropagation();
        this.setState({visible: val});
    };

    createHtml = str => ({__html: str ? str : `&nbsp;`});

    render() {
        let {visible} = this.state
        const {num} = this.props;
        let originData = this.props.data;
        let stem = JSON.parse(originData.stem);
        let data = reverseParseTextView(originData);
        return (
            <div className='box-exercise' ref={'viewer'}>
                <div className="exercise-content">
                    {num !== 'undefined' &&
                    <div className="exercise-num"><span className="math_text">{`${num + 1}、`}</span></div>}

                    <div className="exercise-con">
                        <Row>
                            <Col span={4}>
                                <span className="form-label">引导语：</span>
                            </Col>
                            <Col span={20}>
                                <div className="form-content">{stem.question}</div>
                            </Col>
                        </Row>

                        {
                            stem.guide_audio &&
                            <Row>
                                <Col span={4}>
                                    <span className="form-label">引导音频：</span>
                                </Col>
                                <Col span={20}>
                                    <div className="form-content">
                                        <audio src={stem.guide_audio} controls="controls" width={300}/>
                                    </div>
                                </Col>
                            </Row>
                        }

                        {
                            stem.image_url &&
                            <Row>
                                <Col span={4}>
                                    <span className="form-label">题干图片：</span>
                                </Col>
                                <Col span={20}>
                                    <div className="form-content">
                                        <img src={stem.image_url} width={300}/>
                                    </div>
                                </Col>
                            </Row>
                        }

                        <Row>
                            <Col span={4}>
                                <span className="form-label">题干：</span>
                            </Col>
                            <Col span={20}>
                                <div className="form-content">
                                    {
                                        typeof (stem.content) == 'string' ?
                                        stem.content.replace(/\$/g , '__')
                                            :stem.content.map(i => i === '$' ? '__' : i)
                                    }
                                </div>
                            </Col>
                        </Row>

                        <Row>
                            <Col span={4}>
                                <span className="form-label">选项：</span>
                            </Col>
                            <Col span={20}>
                                {
                                    stem.item_list.map((i,index) =>
                                        <Tag color="purple" key={index}>{i}</Tag>
                                    )
                                }
                            </Col>
                        </Row>

                    </div>
                </div>

                {/*    footer*/}
                <div className="exercise-footer">
                    {
                        visible &&
                        <div className="footer-hide relative">
                            <div>
                                <div className="inline-block"><span
                                    style={{fontSize: 14}}>{this.props.errorAnswer ? '错误答案：' : '正确答案：'}</span></div>
                                <div className="inline-block" style={{width: '80%'}}>
                                    <span style={{fontSize: 14}}
                                          dangerouslySetInnerHTML={this.createHtml(JSON.parse(originData.answer))}/>
                                </div>
                            </div>
                            {
                                data.explain && <div>
                                    <div className="inline-block"><span style={{fontSize: 14}}>答案解析：</span></div>
                                    <div className="inline-block">
                                        <span style={{fontSize: 14}}
                                              dangerouslySetInnerHTML={this.createHtml(data.explain)}/>
                                    </div>
                                </div>
                            }
                        </div>
                    }
                    <div className="footer-show relative">
                        <Footer {...this.props} obj={originData} subject={this.props.data.subject}>
                            {
                                this.props.canShowAnswer ?
                                    <button
                                        className="question-btn"
                                        onClick={(e) => this.toggleAnswer(!visible, e)}>
                                        {!visible ? '显示答案' : '隐藏答案'}
                                    </button> : null

                            }
                        </Footer>
                    </div>
                </div>
            </div>
        )
    }
}

export default Question;



// WEBPACK FOOTER //
// ./src/entry_question_editor/question/ai_word_spell/viewForView.js